module.exports = __webpack_public_path__ + "media/images/common/ico-rank-3-8286cdf3ecddee89ed1698a87b0c615d.svg";